export default {
  slAdminAccounts: [],
  slAdminAccountsLoading: false,
  slAccounts: [],
  slViews: [],
  isFetchingInitialDataForAddAndEditModal: false,
};
